<div class="relative flex flex-col gap-2 w-full">
  <div class="luces-difusas-bg">
    <div class="luces-difusas-vertical">
      <span class="luz-difusa luz-usuario"></span>
      <span class="luz-difusa luz-equipo"></span>
      <span class="luz-difusa luz-app"></span>
    </div>
  </div>
  <div
    class="flex flex-col gap-2 w-full"
    style="position: relative; z-index: 1"
  >
    <button
      type="button"
      (click)="agregarUsuario()"
      class="flex items-center gap-3 px-2.5 py-2 rounded-[20px] cursor-pointer text-[12px] text-white transition-all w-full"
      style="background: #3b3a3e"
    >
      <img src="assets/images/icons/Vector (4).png" alt="Icono usuario" class="w-[24px] h-[24px]" />
      <span class="whitespace-nowrap">Agregar Nuevo Usuario</span>
    </button>
    <button
      type="button"
      (click)="agregarEquipo()"
      class="flex items-center gap-3 px-2.5 py-2 rounded-[20px] cursor-pointer text-[12px] text-white transition-all w-full"
      style="background: #3b3a3e"
    >
      <img src="assets/images/icons/Vector (6).png" alt="Icono grupo" class="w-[24px] h-[24px]" />
      <span class="whitespace-nowrap">Agregar Nuevo Grupo</span>
    </button>
    <button
      type="button"
      (click)="agregarApp()"
      class="flex items-center gap-3 px-2.5 py-2 rounded-[20px] cursor-pointer text-[12px] text-white transition-all w-full"
      style="background: #3b3a3e"
    >
      <img src="assets/images/icons/Vector (7).png" alt="Icono aplicación" class="w-[24px] h-[24px]" />
      <span class="whitespace-nowrap">Agregar Nueva Aplicación</span>
    </button>
  </div>
</div>
